import type { ReactNode } from 'react';
import { cn } from './ui-x';

type Props = {
  /**
   * Table pages need more room than the reference's talent screens, which are
   * narrow reading pages. Wide is max-w-6xl; the default is max-w-3xl.
   */
  wide?: boolean;
  className?: string;
  children: ReactNode;
};

/**
 * The page wrapper. <main> pays the padding (see Layout), so this only owns
 * the width constraint and the vertical rhythm — never re-apply page padding
 * here or on a page.
 */
const PageShell = ({ wide, className, children }: Props) => (
  <div
    className={cn(
      'mx-auto w-full space-y-6',
      wide ? 'max-w-6xl' : 'max-w-3xl',
      className
    )}
  >
    {children}
  </div>
);

export default PageShell;
